import { PureComponent } from 'react';
export class ErrorBoundary extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isError: false
        };
    }
    static getDerivedStateFromError() {
        return { isError: true };
    }
    componentDidCatch(error, errorInfo) {
        const { captureException } = this.props;
        captureException(error, errorInfo);
    }
    render() {
        const { fallback } = this.props;
        const { isError } = this.state;
        if (isError) {
            return fallback;
        }
        return this.props.children;
    }
}
